import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {SSO_LOGIN} from "./type";

export const ssoGoogleLogin = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.login.ssoLogin}`
    );
    if (res) {
        const {data} = res;
        console.log(res)
        // console.log(data)
        dispatch({type: SSO_LOGIN, payload: data});
        return res.data.response;
    }
};
